import { CSSProperties, MutableRefObject, useEffect, useRef, useState } from 'react'
import styles from './ChangeMarkPoint.module.scss'

export const useChangePlageAbsolutePosition = (): {
  containerRef: MutableRefObject<HTMLDivElement>
  plateStyle: CSSProperties
} => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [plateStyle, setPlateStyle] = useState<CSSProperties>()

  useEffect(() => {
    if (!containerRef.current) return

    const getOffset = (el: HTMLElement) => {
      const rect = el.getBoundingClientRect()
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      }
    }

    const windowWidth = window.innerWidth
    // const windowHeight = window.innerHeight
    const containerWidth = containerRef.current.clientWidth
    const containerHeight = containerRef.current.clientHeight
    const {
      // top: containerTop,
      left: containerLeft
    } = getOffset(containerRef.current)

    const plateWidth = 370
    // const plateHeight = 300

    const positionCorrection = Number(styles.containerPadding)

    const top = containerHeight - 2 * positionCorrection

    const left = containerLeft + containerWidth + plateWidth > windowWidth
      ? -plateWidth + containerWidth - positionCorrection
      : positionCorrection

    setPlateStyle({
      // position: 'fixed',
      top,
      left
    })
  }, [containerRef])

  // useEffect(() => {
  //   window.addEventListener('scroll', (ev: Event) => {
  //     console.log('EV', ev)
  //   })
  // }, [])

  return {
    containerRef,
    plateStyle
  }
}
